import { Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import AIPhoneAgentApp from "./screen/AIPhoneAgentApp";
import "./App.css";


function App() {
  return (
    <Routes>

      <Route path="/" element={
          <AIPhoneAgentApp />
      } />
      
      <Route path="*" element={<h1>Error</h1>} />
    </Routes>

    
  );
}

export default App;
